import { render, staticRenderFns } from "./WxbookPrivate.vue?vue&type=template&id=baf7e97e&scoped=true&"
import script from "./WxbookPrivate.vue?vue&type=script&lang=js&"
export * from "./WxbookPrivate.vue?vue&type=script&lang=js&"
import style0 from "./WxbookPrivate.vue?vue&type=style&index=0&id=baf7e97e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf7e97e",
  null
  
)

export default component.exports